import { TestEvent } from "@/api/williams/testEvents";
import { Warning } from "../../components/alerts";
import { useAdvisories } from "../hooks";

export function TEFormAdvisories({ data }: { data: Readonly<TestEvent> }) {
  const advisories = useAdvisories(data);
  return (
    <div className="mt-4">
      {advisories.data?.map((advisory) => (
        <Warning key={advisory}>{advisory}</Warning>
      ))}
    </div>
  );
}
